import { BRAND_LOGOS } from "../data/brochure";

const half = Math.ceil(BRAND_LOGOS.length / 2);
const ROWS = [BRAND_LOGOS.slice(0, half), BRAND_LOGOS.slice(half)];

const LogoRow = ({ logos, reverse, testId }) => (
  <div className="brands-row" data-testid={testId}>
    <div className={`brands-track ${reverse ? "reverse" : ""}`}>
      {[...logos, ...logos].map((logo, i) => (
        <div className="brand-logo" key={`${logo.key}-${i}`} aria-hidden={i >= logos.length}>
          <img src={logo.src} alt={logo.name} title={logo.name} loading="lazy" />
        </div>
      ))}
    </div>
  </div>
);

export const TrustedBrands = ({ innerRef }) => (
  <section id="clients" className="brands-section section-animate" ref={innerRef} data-testid="brands-section">
    <div className="section-header">
      <h2 className="section-title" data-testid="brands-title">Trusted by Leading Brands</h2>
      <div className="section-divider"></div>
      <p className="section-subtitle">Organisations across Malaysia and beyond that have trained with Fit Farm, and many more.</p>
    </div>
    <LogoRow logos={ROWS[0]} testId="brands-row-1" />
    <LogoRow logos={ROWS[1]} reverse testId="brands-row-2" />
  </section>
);
